var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSimpleItemList(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 110,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.6185 64.8338L48.1763 71.7524L51.3132 75.1197L64.8453 62.5337L51.3132 49.9477L48.1763 53.315L55.6185 60.2336H31.2956C25.9509 60.2336 21.5996 55.8819 21.5996 50.5365L21.6088 37.5733H17V50.5365C17 58.4212 23.4119 64.8338 31.2956 64.8338H55.6185Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.4733 38.6313C93.4641 38.2265 93.3537 37.8217 93.1146 37.4537C93.1054 37.4445 93.1054 37.4353 93.0962 37.4168V37.4076C93.0962 37.4076 93.0962 37.4076 93.0962 37.3984L84.1545 23.9936C83.7405 23.3772 83.0414 23 82.2962 23H41.7275C40.9824 23 40.2833 23.3772 39.8693 23.9936L30.9276 37.4076C30.9276 37.4076 30.9276 37.4168 30.9184 37.4168V37.4261C30.9092 37.4353 30.9092 37.4445 30.9 37.4537C30.6792 37.7941 30.5505 38.1989 30.5413 38.6313C30.5413 38.6405 30.5413 38.6497 30.5413 38.6681V38.6773V38.6865V54.8882H35.0121V40.9038H53.061H57.5319H66.4827H70.9536H89.0025V82.4891H35.0213V69.6087H30.5505V87.0892H30.6792H35.0305H89.0209H93.2433H93.5009V38.6773V38.6681V38.6589C93.4825 38.6497 93.4733 38.6405 93.4733 38.6313ZM59.7213 36.4232H36.9623L42.9235 27.4713H59.7213V36.4232ZM64.1921 36.4232V27.4713H81.0911L87.0523 36.4232H64.1921Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.4826,
    height: 64.08,
    fill: "white",
    transform: "translate(17 23)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimpleItemList);
export default __webpack_public_path__ + "static/media/simple-item-list.80ad28fecb622dd1e2e6e23c6928e477.svg";
export { ForwardRef as ReactComponent };